import { useSelector } from 'react-redux'
import Vimeo from '@u-wave/react-vimeo'
import { t } from '../../utils/i18n'
import { isDanish } from '../../utils/url'
import Popover from '../Popover'
import { getVimeoId } from '../../utils/bike-schema'

const align =
  window.innerWidth > 768
    ? '.velorbis-customizer-header-video'
    : '.velorbis-customizer-header-video-mobile'

const VideoPopover = () => {
  const { baseModelId } = useSelector((state) => state.bikeConfig)
  const vimeoId = getVimeoId(baseModelId)

  return (
    isDanish && (
      <Popover
        className="video-popover"
        alignTo={
          vimeoId && isDanish ? align : '.velorbis-customizer-header-tool-inner'
        }
        position="below"
        show={vimeoId}
      >
        <div className="velorbis-customizer-popover-header">
          {t('bike_video')}
        </div>
        <div className="velorbis-customizer-popover-body velorbis-customizer-popover-body-no-padding velorbis-customizer-popover-body-scroll velorbis-customizer-presets-popover-inner">
          {vimeoId ? (
            <Vimeo className="vimeo-embed" autoplay video={`${vimeoId}`} />
          ) : (
            <div>Video preview is not available.</div>
          )}
        </div>
      </Popover>
    )
  )
}

export default VideoPopover
